import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { spacing, colors } from 'ui/theme';

import { pxToRem } from 'utils/convert';

const Wrapper = styled.div`
  width: ${pxToRem(208)};
`;

const SkeletonNavItem = styled(Skeleton)<{ $width: string }>`
  height: ${spacing.plusHalf};
  margin: 0 ${spacing.base} ${spacing.half} 0;
  background-color: ${colors.grey5};
  width: ${({ $width }) => $width};
`;

export const UserProfilesSideNavSkeleton = () => (
  <Wrapper data-test="user-profile-sidenav-skeleton">
    <SkeletonNavItem $width="80%" />
    <SkeletonNavItem $width="70%" />
    <SkeletonNavItem $width="50%" />
  </Wrapper>
);
